export const validation = {
  noSpace: "No blank space is allowed at start and end",
};
